import { PageLimitFilter } from '@typings';

import { baseClient } from 'src/app/baseClient';

import {
  OfferBulkImportApiRequest,
  OfferBulkImportApiResponse,
} from '../interfaces/offerBulkImport';
import {
  ProductByIdResponse,
  ProductDto,
  ProductPayload,
  ProductsResponse,
  ProductUpdatePayload,
  ProductUpdateResponse,
  Provider,
  ProviderProductDto,
} from '../interfaces/productInterface';
const VERSION_API = 'v2';

async function getProductsByPage({
  page,
  limit,
  filter,
  order: ordered,
}: PageLimitFilter) {
  const endpoint = `/products/${VERSION_API}/product-sell-group`;
  let where = {};
  if (filter) {
    Object.keys(filter).forEach(key => {
      if (filter[key]) {
        where = {
          ...where,
          [key]: filter[key],
        };
      }
    });
  }

  const order = !ordered || ordered === '' ? '[id,DESC]' : ordered;

  const response = await baseClient.get<{ total: number; data: ProductDto[] }>(
    endpoint,
    {
      params: {
        ...where,
        limit,
        page,
        order,
      },
    }
  );

  const responseData: ProductsResponse = {
    count: response.data.total,
    rows: response.data.data,
  };

  return responseData;
}

async function getProfiles() {
  const endpoint = `/user/profiles`;
  const response = await baseClient.get<ProviderProductDto>(endpoint);

  return response.data?.profiles || [];
}

async function createProduct(payload: ProductPayload) {
  const endpoint = `/products/${VERSION_API}/composite-products`;
  const { data } = await baseClient.post<{ productSellGroup: ProductDto }>(
    endpoint,
    payload
  );

  const createdProduct = data.productSellGroup;

  return createdProduct;
}

async function getProductById(productId: number): Promise<ProductByIdResponse> {
  const endpoint = `/products/${VERSION_API}/product-sell-group/${productId}`;
  return (await baseClient.get(endpoint)).data;
}

async function updateProduct(
  productId: number,
  payload: ProductUpdatePayload
): Promise<ProductUpdateResponse> {
  const endpoint = `/products/${VERSION_API}/product-sell-group/${productId}`;
  const result = await baseClient.put<ProductUpdateResponse>(endpoint, payload);

  return result.data;
}

async function getProviders() {
  const endpoint = `/subscription/gateway`;
  const result = await baseClient.get<Provider[]>(endpoint);

  return result.data;
}

async function getCategories() {
  const endpoint = `/products/${VERSION_API}/categories`;
  const result = await baseClient.get<{ id: number; name: string }[]>(endpoint);

  return result.data;
}

async function toggleStatusProduct(productId: number, activeChange: boolean) {
  const endpoint = `/products/${VERSION_API}/product-sell-group/${productId}/toggle-status`;
  const result = await baseClient.patch(endpoint, {
    active: activeChange,
  });

  return result.data;
}

async function importOffersBulk(
  payload: OfferBulkImportApiRequest
): Promise<OfferBulkImportApiResponse> {
  const endpoint = `/products/${VERSION_API}/offers/bulk`;
  const { data } = await baseClient.post<OfferBulkImportApiResponse>(
    endpoint,
    payload
  );

  return data;
}

export const productApi = {
  createProduct,
  getProductById,
  updateProduct,
  getProductsByPage,
  getProfiles,
  getCategories,
  getProviders,
  toggleStatusProduct,
  importOffersBulk,
};
